import { render, staticRenderFns } from "./heatnumber.vue?vue&type=template&id=be472198&scoped=true&"
import script from "./heatnumber.vue?vue&type=script&lang=js&"
export * from "./heatnumber.vue?vue&type=script&lang=js&"
import style0 from "./heatnumber.vue?vue&type=style&index=0&id=be472198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be472198",
  null
  
)

export default component.exports